export default __webpack_public_path__ + "static/media/Gli studenti e Pino cacucci.41555ac9.jpg";